
import * as fromActions from '../actions';
import { EmailDataState } from '../models/store.models';

const initialState: EmailDataState = {
    email: null,
    nombre: null,
    tipoOperador: null
}

export function emailSenderStateReducer(state: EmailDataState = initialState, action: fromActions.EmailSenderActions): EmailDataState {
    switch (action.type) {
        case fromActions.SET_EMAIL:
            return {
                ...state,
                email: action.email
            }
        case fromActions.UNSET_EMAIL:
            return {
                ...state,
                email: null
            }
        case fromActions.SET_NAME:
            return {
                ...state,
                nombre: action.name
            }
        case fromActions.UNSET_NAME:
            return {
                ...state,
                nombre: null
            }
        case fromActions.SET_OPERATOR_TYPE:
            return {
                ...state,
                tipoOperador: action.operatorType
            }
        case fromActions.UNSET_OPERATOR_TYPE:
            return {
                ...state,
                tipoOperador: null
            }
        default:
            return state
    }
}
